<template>
    <div
      class="modal fade"
      id="modal-form-finalizar-viaje"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog">
        <div class="modal-content">
  
          <div class="modal-header bg-danger">
            <h5 class="modal-title">
              Finalizar Viaje
            </h5>
  
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              ref="closeModal"
            >
              <span>&times;</span>
            </button>
          </div>
  
          <div class="modal-body">
  
            <div class="form-group">
              <label>Fecha y hora finalización</label>
  
              <input
                type="datetime-local"
                class="form-control"
                v-model="form.fecha_finalizacion"
              >
            </div>
  
            <div class="form-group">
              <label>Observación</label>
  
              <textarea
                class="form-control"
                rows="3"
                v-model="form.observacion"
              ></textarea>
            </div>
  
            <div class="alert alert-warning">
              ¿Está seguro de finalizar este viaje?
            </div>
  
          </div>
  
          <div class="modal-footer">
  
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cancelar
            </button>
  
            <button
              type="button"
              class="btn btn-danger"
              @click="finalizarViaje"
            >
              Finalizar
            </button>
  
          </div>
  
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from "axios";
  import moment from "moment";
  
  export default {
    name: "PlantVentanaOperacionesFinalizarViaje",
    data() {
      return {
        viaje: null,
  
        form: {
          fecha_finalizacion: "",
          observacion: "",
        },
      };
    },
  
    methods: {
      abrir(viaje) {
        this.viaje = viaje;
  
        this.form = {
          fecha_finalizacion: moment().format("YYYY-MM-DDTHH:mm"),
          observacion: "",
        };
      },
  
      finalizarViaje() {
        axios
          .put(
            `/api/plant/ventanasEnturnamientoOperacion/finalizarViaje`,
            {
              viaje_id: this.viaje.id,
              fecha_finalizacion: this.form.fecha_finalizacion,
              observacion: this.form.observacion,
            }
          )
          .then(() => {
  
            this.$refs.closeModal.click();
  
            this.$swal({
              icon: "success",
              title: "Viaje finalizado correctamente",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            });
  
            this.$emit("actualizar");
          })
          .catch(() => {
            this.$swal({
              icon: "error",
              title: "Ocurrió un error al finalizar el viaje",
            });
          });
      },
    },
  };
  </script>